$(document).ready(function() {
  //$('.zoom').magnify();


  
  // $(".icon").live('click', function(){
  //   console.log('hi');
  // });

});

// $(window).scroll(function(){
//   var sticky = $('.product-info__block-item[data-block-type="price"]'),
//       scroll = $(window).scrollTop();

//   if (scroll >= 100) sticky.addClass('fixed');
//   else sticky.removeClass('fixed');
// });

// $( function() {
//   $( document ).tooltip({
//     position: {
//       my: "center bottom-20",
//       at: "center top",
//       using: function( position, feedback ) {
//         $( this ).css( position );
//         $( "<div>" )
//           // .addClass( "arrow" )
//           .addClass( feedback.vertical )
//           .addClass( feedback.horizontal )
//           .appendTo( this );
//       }
//     }
//   });
// } );

// jQuery('.product-gallery__media img').extm();





// Detect Safari/iOS
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isIOS || isSafari) {
  const optionToHide = document.querySelector('select.cl-po--input option[value="Select Any"]');
  optionToHide?.remove();
}

//replace all option that contain text with div
function hideSome(){
  var nodesSnapshot = document.evaluate("//select/option[text()[contains(.,'Select')]]", document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
  console.log('hide');
  for (var i = 0; i < nodesSnapshot.snapshotLength; i++) {
    var nodeA = nodesSnapshot.snapshotItem(i);
    var elemA = document.createElement('div');
    elemA.innerHTML = nodeA.innerHTML;
    nodeA.parentNode.replaceChild(elemA, nodeA);
  }
}
hideSome();

$(document).ready(function () {

  

   updateCartQuantity();
    $(".at-title").click(function () {
      $(this)
        .toggleClass("active")
        .next(".at-tab")
        .slideToggle()
        .parent()
        .siblings()
        .find(".at-tab")
        .slideUp()
        .prev()
        .removeClass("active");
    });

  

  //IMAGE EDIT & CROP SECTION
 $(".crop-image").hide();
  ///Upload Image 
    var cropper; 
    // When the file input changes (i.e., an image is selected)
    $('#upload-image').change(function(event) {
        var input = event.target; 
        $(".crop-image").show();

      /*document.addEventListener("DOMContentLoaded", () => {
          const form = document.querySelector("form[novalidate]");
          form && form.removeAttribute("novalidate");
      });*/
        // Ensure a file is selected
        if (input.files && input.files[0]) {
            var reader = new FileReader(); 
            reader.onload = function(e) { 
              
                // Set the image source to the selected file's data URL
               //$('.product-gallery__media img').attr('srcset', e.target.result).show();
                $('#imagePreview').attr('src', e.target.result).show();

                // Destroy any existing cropper instance
                if (cropper) {
                    cropper.destroy();
                }

                // Initialize Cropper.js
                cropper = new Cropper(document.getElementById('imagePreview'), {
					aspectRatio: NaN,  
                    viewMode: 1,
                   // aspectRatio: 1,        // Aspect ratio for the cropping area
                    autoCropArea: 1,       // Set the crop area to cover the full image by default
                    scalable: true,
                    zoomable: true,
                    movable: true,
                    rotatable: true
                });
            };
            reader.readAsDataURL(input.files[0]);
        }
    }); 
  
    // Handle the crop button click
    $('.crop-image').click(function() {
        if (cropper) {
          $(".crop-image").hide();
            // Get the cropped canvas
            var canvas = cropper.getCroppedCanvas({
                width: 1080,          // Output image width
                height: 1080          // Output image height
            });
            // Convert the canvas to a data URL and set it as the new image source
            var croppedImageUrl = canvas.toDataURL();
            // Destroy the cropper instance to free up memory
            cropper.destroy();
            // Replace the original image with the cropped one in the same container
            $('#imagePreview').attr('src', croppedImageUrl).css("display", "block");
          $('#hidden_upload').val(croppedImageUrl);
        }
    });

  
  

  
});
//$('.h-stack').on('click', function() { 
  $(document).on('click', 'line-item-quantity', function () {
     setTimeout(function () {
      updateCartQuantity();
       console.log('hi');
       }, 1000);
  });

//End section

// Add to cart functionality
    $('#add_to_cart').click(function(event) {
        event.preventDefault();
      var variantId = $(this).val();
     var quantity = $("input[name=quantity]").val(); 
      var cust_price = $("#cust_price").val();
     const fileInput = document.getElementById('upload-image');
      const file = fileInput.files[0];
     // console.log(file);
     // return false;
// Add main product to cart with combined Width and Length
      //const reader = new FileReader();
    //reader.onload = function (event) {
     // const fileBase64 = event.target.result; // Base64 representation of the file
  var arr = []; 
    arr.unshift({
        id: variantId,
        quantity: quantity, 
        properties: {
            'Style': quantity,
             'Custom Price': cust_price
          //   "Uploaded File": fileBase64 // Store the uploaded file in line item properties
            
        },
    });
     // console.log(arr);
      //return false;
      
      // AJAX request to add items to cart
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: arr }),
            contentType: 'application/json',
            dataType: 'json',
            success: function(response) {
              
               updateCartQuantity();
               /* $('.cart-count-bubble').click();
                $('cart-drawer').removeClass('is-empty');
                $('.drawer__inner').hide();
                $('cart-drawer').load(location.href + " #CartDrawer", function() {
                    $.getJSON('/cart.js', function(cart) {
                      console.log(cart.item_count);
                        $('.cart-count-bubble').html(cart.item_count);
                    });
                });*/
            },
            error: function(xhr, status, error) {
                console.log('Error adding items to cart:', xhr.responseText);
            }
        });
     // };

    // Convert the file to Base64
   // reader.readAsDataURL(file);
    });

  // Function to update the cart quantity in the header
  function updateCartQuantity() { 
      fetch('/cart.js', {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json'
          }
      })
      .then(response => response.json())
      .then(cart => {
        let totalPrice = cart.total_price; // Base price in cents
        
        console.log(totalPrice);
        cart.items.forEach((item, index) => {
          
                if (item.properties['Custom Price']) {
                    // Add-on price adjustment (convert to cents if needed)
                    totalPrice += parseFloat(item.properties['Custom Price'].replace('$', '')) * 100;
                }
           
                let itemHtml = jQuery('body').find('#cart-drawer .line-item').eq(index);
              if(item.properties['Installation'] == 'yes') {

                  item_id   = itemHtml.attr('data-live-item-key');
                
                  let _dimension_installation_x  = item.properties['_Dimension Installation_x'];
                  let _dimension_installation_y  = item.properties['_Dimension Installation_y'];
                  let area                       = (parseInt(_dimension_installation_x)*parseInt(_dimension_installation_y))/144;
                  let installationPerPrice       = 5;
                  let installatioPrice           = installationPerPrice * area;
                  if(installatioPrice < 1000){installatioPrice = 999;}
                
                   installatioPrice = installatioPrice.toFixed(2);
                  let newInstContent   = 'Dimension: '+_dimension_installation_x+'x'+_dimension_installation_y+' | $'+installatioPrice;
                      newInstContent   = newInstContent+" <a class='remove-installation' data-vid='"+item_id+"' data-item='"+JSON.stringify(item)+"'>X</a>";
                      itemHtml.find('[data-p-dimension_installation="1"]').html(newInstContent);
    
              }else{
                   let _dimension_installation_x  = item.properties['_Dimension Installation_x'];
                   let _dimension_installation_y  = item.properties['_Dimension Installation_y'];
                   let newInstContent   = 'Dimension: '+_dimension_installation_x+'x'+_dimension_installation_y;
                   itemHtml.find('[data-p-dimension_installation="1"]').html(newInstContent);
              }
               
          
            });

        //  console.log(cart.items);


        
            console.log('Total Price:', (totalPrice / 100).toFixed(2)); 
        //$(".cart-drawer__button-price").text((totalPrice / 100).toFixed(2));
          //const cartQuantityElement = document.getElementById('cart-quantity');
          //cartQuantityElement.textContent = cart.item_count; // Update the cart quantity
        
        
      })
      .catch(error => console.error('Error fetching cart details:', error));
    }
 

  // Example Usage: Adding a product to the cart
  /*document.getElementById('add-to-cart-button').addEventListener('click', function () {
      const variantId = 50527903580434; // Replace with your product variant ID
      addToCart(variantId, 1);
  });
*/

////end

jQuery('body').on("click",".remove-installation",function(){
  let vid     = jQuery(this).attr('data-vid');
  let itemStr  = jQuery(this).attr('data-item');
  var item      = JSON.parse(itemStr);
  console.log(item);
  item['properties']['Installation'] = '';
  let _cl_options_json  = JSON.parse(item['properties']['_cl_options_json']);
  _cl_options_json['Installation'] = '';
   item['properties']['_cl_options_json'] = _cl_options_json;

 // let update = {'id':item['id'],'properties':_cl_options_json}
  // let update = {'id':'50784835535122','properties':{'Installation':''}}
  let id  = jQuery.trim(item['id']);
  
  let update  = { 'properties': item['properties'], 'id':id}
  /*
  let price = '1000';
   let update  = { 
                 'discounted_price': price,
                 'final_line_price':price,
                 'final_price':price,
                 'line_price':price,
                 'original_line_price': '10.00', 
                 'original_price': price,
                  'price':'',
                'id':id}*/
//console.log(update);

fetch('/cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(update )
})
.then(response => {
 // return response.json();
   window.location.href = '/cart';
})
.catch((error) => {
  console.error('Error:', error);
});

  

});






jQuery(".drawer-triger").on("click",function(){
    var id = jQuery(this).attr('rel');
    //console.log("#information-drawer-"+id);
    jQuery('.information-drawer').removeClass('slideIn');
    jQuery("#"+id).addClass('slideIn');
    jQuery(".overlay").fadeIn(500);
});

jQuery("span.close, .overlay").on("click",function(){
    jQuery('.information-drawer').removeClass('slideIn');
    jQuery(".overlay").fadeOut(100);
});


if(jQuery('.testimonial-slider').length){

    var splide = new Splide( '.testimonial-slider', {
      perPage: 3,
      rewind : true,
      type   : 'loop',
      autoplay: true,
      gap: "2rem",
      arrows:false,
      pagination:false,
      breakpoints :{
          1199:{
              perPage: 2
          },
          900:{
              perPage: 1
          }
      }
  });
    
  splide.mount();
}



if(jQuery('.shopify-section--main-product').length){

  jQuery('body').on("change",".cl-po--option[data-option='Special Effects'] .cl-po--input",function(){
    
       let s_e_val = jQuery(this).val();
       let s_e_class="";
       jQuery('body').find('.product-gallery').removeClass('special_effects_black_and_white').removeClass('special_effects_sepia').removeClass('special_effects_monochromatic').removeClass('special_effects_fade');
     
       if(s_e_val=='Black and white'){
          s_e_class  = 'special_effects_black_and_white';
       }else if(s_e_val=='Sepia'){
          s_e_class  = 'special_effects_sepia';
       }else if(s_e_val=='Monochromatic'){
         s_e_class  = 'special_effects_monochromatic';
       }else if(s_e_val=='Fade'){
         s_e_class  = 'special_effects_fade';
       }
      jQuery('body').find('.product-gallery').addClass(s_e_class);
  });

   let viysInterval = setInterval(function () {
       //jQuery('body').find(".cl-po--option[data-option='view_in_your_space'] .cl-po--swatch-container").hide();
         jQuery('body').find(".cl-po--option[data-option='view_in_your_space']").hide();
              if(jQuery('body').find(".cl-po--option[data-option='view_in_your_space']").not(':visible')){
                clearInterval(viysInterval);
              }
       }, 500);

     //jQuery('body').on("click",".cl-po--option[data-option='view_in_your_space'] .cl-po--label",function(){
   jQuery('body').on("click","[data-block-id='modal_xtR4hR1']",function(){
           // jQuery('body').find('.modal').show();
            //jQuery('body').find('.modal .h5').html('X');
           let clone_html =   jQuery('body').find(".cl-po--option[data-option='view_in_your_space'] .cl-po--swatch-container").clone();
              //clone_html.show();
             //clone_html.removeAttr("style");
           // jQuery('body').find('.modal .prose').html(clone_html);
             jQuery('body').find('x-modal[id$="__mainmodal_xtR4hR1"] .prose').html(clone_html);

     });

    jQuery('body').on("click",".modal .cl-po--swatch-container img",function(){
  
              let img_src  = jQuery(this).attr('src');
              img_src = img_src.replace("_400x.", ".");
              let img_tag = '<img src="'+img_src+'" class="preview_view_in_your_space">';
              jQuery( ".preview_view_in_your_space" ).resizable();
              /*
              jQuery('body .product-gallery__image-list .cl-po--preview').find('.preview_view_in_your_space').remove();
              jQuery('body .product-gallery__image-list .cl-po--preview').prepend(img_tag);
               */
               jQuery('body .product-gallery__image-list .product-gallery__media').find('.preview_view_in_your_space').remove();
               jQuery('body .product-gallery__image-list .product-gallery__media').prepend(img_tag);
      


      
              jQuery('body').find('.modal').hide();
              $(".preview_view_in_your_space").resizable({ handles: "all", ghost: true, autoHide: true, animate: true }).parent().draggable();
              
              /* $(document).on('click', 'img.preview_view_in_your_space', function () {
                  
              });*/
              jQuery('.product-gallery__media').removeClass('remove');
              jQuery('.remove_preview').css({"display": "flex"});
     });

     jQuery('body').on("click",".remove_preview p",function(){
      jQuery('.product-gallery__media').addClass('remove');
      jQuery('.remove_preview').hide();
     });

/*
jQuery('body').on("click",".cl-po--option[data-option='Installation'] .cl-po--input",function(){
  if(jQuery(this).is(':checked')){
   setCookie("yofee_installation", 'yes', 1);
   }else{
      setCookie("yofee_installation", 'no', 1);
   }
  updateInstallation();
});
  */

jQuery('body').on("click",".cl-po--option[data-option='flip_image'] input[type='checkbox']",function(){
  
  jQuery('body').find('.product-gallery').removeClass('flip_image');
  
  if(jQuery(this).is(':checked')){
      jQuery('body').find('.product-gallery').addClass('flip_image');
   }
});


jQuery('body').on("click",".product-info__block-item[data-block-id='button_xtR4hrsm']",function(){
  //jQuery('.buy-buttons button[type="submit"]').click();
 //console.log('kkkkkkkkkkk');

   let formData = {
       'items': [{
        'id': 50784835535122,
         'line_price': 5,
         'final_price': 5,
         'original_line_price' : 5,
        'quantity': 1
        }]
      };
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });


 
  
/*
  console.log('ssss');
        // AJAX request to add items to cart
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: arr }),
            contentType: 'application/json',
            dataType: 'json',
            success: function(response) {
              
               updateCartQuantity();
                $('.cart-count-bubble').click();
                $('cart-drawer').removeClass('is-empty');
                $('.drawer__inner').hide();
                $('cart-drawer').load(location.href + " #CartDrawer", function() {
                    $.getJSON('/cart.js', function(cart) {
                      console.log(cart.item_count);
                        $('.cart-count-bubble').html(cart.item_count);
                    });
                });
            },
            error: function(xhr, status, error) {
                console.log('Error adding items to cart:', xhr.responseText);
            }
        });
  */



  
});



if(jQuery('body').find('.cart-drawer__items').length){
      setInterval(function () {

              jQuery('body').find('.cart-drawer__items li[data-p-height=1]').each(function(i,e){
                
                let height = jQuery(this).text().split("|");
               // console.log(height[0]);
                jQuery(e).html(height[0]);
              })
             // console.log('fffffffff');
         }, 50); 

 
}


  //var default_price_str = jQuery('body').find('.prose.grade-details ul li:nth-child(1) strong').text();
    var default_price_str = jQuery('body').find('.prose.grade-details ul li:first strong').text();
   // var default_price_str = jQuery('body').find('.product-info__block-item.fixed .price-list--product .text-subdued').text();  
   
    var default_price     =  default_price_str.replace('price','').replace('Price','').replace('/sq. ft.','');
    default_price        =  jQuery.trim(default_price);

 
  jQuery('body').on('click','.buy-buttons button[type="submit"]',function(){


            setInterval(function () {

              jQuery('body').find('.cart-drawer__items li[data-p-height=1]').each(function(i,e){
                
                let height = jQuery(this).text().split("|");
               // console.log(height[0]);
                jQuery(e).html(height[0]);
              })
             // console.log('fffffffff');
         }, 50); 

setTimeout(function () {
     jQuery('body').find('input[name="properties[_Width_x]"]').val('');
     jQuery('body').find('input[name="properties[_Height_x]"]').val('');

     jQuery('body').find('input[name="properties[_Width_y]"]').val('0');
     jQuery('body').find('input[name="properties[_Height_y]"]').val('0');

     //jQuery('body').find('product-form form')[0].reset();

      
      jQuery('body').find('.prose.grade-details ul li:first strong').attr('data-live-format',default_price);
      jQuery('body').find('.price-list.price-list--product sale-price').attr('data-live-format',default_price);

      jQuery('body').find('.prose.grade-details ul li:first strong').html(default_price+'/sq. ft.');
      jQuery('body').find('.price-list.price-list--product sale-price').html(default_price+'/sq. ft.');


  
    }, 2000); 
    
    /*
        setInterval(function () {
                jQuery('body').find('input[name="properties[_Width_x]"]').val('1');
                // jQuery('body').find('input[name="properties[_Width_x]"]').focus();
                jQuery('body').find('input[name="properties[_Height_x]"]').val('1');
              //jQuery('body').find('input[name="properties[_Height_x]"]').focus();

          jQuery('body').find('input[name="properties[_Width_x]"]').trigger('keyup');
          jQuery('body').find('input[name="properties[_Height_x]"]').trigger('keyup');
              // location.reload();

          }, 1000);
       */
  });

  
  
 jQuery('body').find(".product-info__block-item .show_installation_price").parent().hide();
 jQuery('body').find(".product-info__block-item .show_summary_price").parent().hide();   
 jQuery('body').find(".product-info__block-item .price-list--product").hide();
  

    jQuery('body').on("keyup",'input[name="properties[_Width_x]"], input[name="properties[_Width_y]"], input[name="properties[_Height_x]"], input[name="properties[_Height_y]"]',function(){

     //updateInstallation();
      updateProductSplitPrice();
     
  });
}

function updateProductSplitPrice(){
  
  setInterval(function () {
    //jQuery('body').find(".product-info__block-item .price-list--product").hide();
     jQuery('body').find(".product-info__block-item .show_installation_price").parent().hide();
     jQuery('body').find(".product-info__block-item .show_summary_price").parent().hide();  

      default_price_str = default_price_str.replace('.00', '');
     jQuery('body').find('.prose.grade-details ul li:nth-child(1) strong').removeAttr('data-live-format');
     jQuery('body').find('.prose.grade-details ul li:nth-child(1) strong').html(default_price_str);


    let is_show_installation = 'no';
    let is_material   = 'no';
    let is_dimension  = 'no';
    let is_sample     = 'no';


       let title  = jQuery('body').find(".product-info__block-list .product-title").html();
      
         let mt      = jQuery('body').find('select[name="properties[Material]"]').val();
         let sp      = jQuery('body').find('select[name="properties[Special Effects]"]').val();
         let ef      = jQuery('body').find('select[name="properties[Finish]"]').val();
         let width   = jQuery('body').find('input[name="properties[Width]"]').val();
         let height  = jQuery('body').find('input[name="properties[Height]"]').val();
         let dimension = width+" X"+height;
          jQuery('body').find('input[name="properties[Dimension]"]').val(dimension);

    

      let wno = width.match(/\d+/);
      let hno = height.match(/\d+/);
      let oneQf = wno*hno;

       if(oneQf=='0'){ return false;}
    
       if(oneQf == '1'){
           jQuery('body').find(".cl-po--option[data-option='Installation'] .cl-po--input").prop('checked', false); 
           is_sample  = 'yes';
       }
    

      if(jQuery('body').find(".cl-po--option[data-option='Installation'] .cl-po--input").is(':checked')){

        let ins_text = jQuery('body').find(".cl-po--option[data-option='Installation'] label").text();
        
            ins_text = ins_text.replace('Yes', '').replace('yes', '').replace('(', '').replace(')', '').replace('+', '');
            ins_text = jQuery.trim(ins_text);
        
            if(ins_text){
                
                jQuery('body').find(".product-info__block-item .show_installation_price span").html(ins_text);
                is_show_installation = 'yes';
             }
        
      }

          let dim_text = jQuery('body').find(".cl-po--option[data-option='Dimension'] label").text();
           dim_text = dim_text.replace('Price', '').replace('price', '').replace('(', '').replace(')', '').replace('+', '');
           dim_text = jQuery.trim(dim_text);
    
            if(dim_text){
               is_dimension = 'yes';
            }

          if(is_sample == 'yes'){
             // dim_text = '$0.00';
              dim_text = default_price_str;
          }

          let summaryText  = title;
    
               if(is_dimension == 'yes'){summaryText  = summaryText+', '+width+' x '+height;}
               if(mt && mt.indexOf("Select")== '-1'){summaryText = summaryText+', '+mt; is_material = 'yes';}
               if(sp && sp.indexOf("Select")== '-1'){summaryText = summaryText+', '+sp;}
               if(ef && ef.indexOf("Select")== '-1'){summaryText = summaryText+', '+ef;}
               summaryText = summaryText+':';
    

     //if(is_material == 'yes'){}

       if(is_show_installation == 'yes'){
            jQuery('body').find(".product-info__block-item .show_installation_price").parent().show();
            jQuery('body').find(".price-list--product").parent().parent().show(); 
         }else{
           jQuery('body').find(".price-list--product").parent().parent().hide(); 
         }

        jQuery('body').find(".product-info__block-item .show_summary_price").parent().show();   
        jQuery('body').find(".product-info__block-item .show_summary_price strong").html(summaryText); 
        jQuery('body').find(".product-info__block-item .show_summary_price span").html(dim_text);
    

       
  
  
   }, 500); 
}

function updateInstallation(){
  
   jQuery('body').find(".product-info__block-item .price-list--product").hide();
   jQuery('body').find(".product-info__block-item .show_installation_price").parent().hide();
   jQuery('body').find(".product-info__block-item .show_summary_price").parent().hide();   
  
  setInterval(function () {

    let x  = jQuery('body').find('input[name="properties[_Dimension Installation_x]"]').val();
    let y  = jQuery('body').find('input[name="properties[_Dimension Installation_y]"]').val();
    let area  = '';
   
   if(x && y && (x*y > 0)){
     area  = x*y;
   }else{
      jQuery('body').find(".product-info__block-item .show_installation_price").parent().hide();
      jQuery('body').find(".product-info__block-item .show_summary_price").parent().hide();   
      jQuery('body').find(".product-info__block-item .price-list--product").hide();
   } 

    if(area =='144'){
       jQuery('body').find(".cl-po--option[data-option='Installation'] .cl-po--input").prop('checked', false); 
    }

   if(jQuery('body').find(".cl-po--option[data-option='Installation'] .cl-po--input").is(':checked')){
     
    if(area){

         
    let perqrftPrice = 5;
     
      // For 3D
    // if(jQuery('body').find('[data-block-id="text_BYUmM8"]').length>0){
    //    perqrftPrice  = 19;
    // }
      
           area  = area/144;
          let priceInst = area*perqrftPrice;
          if(priceInst < 1000){priceInst ='999'};
            
          let totalPrice = jQuery('body').find(".product-info__block-item .price-list--product .text-subdued").attr('data-live-format');
             
           
      // console.log('===== 1=> '+totalPrice);
              totalPrice = totalPrice.replace('$', "");
              totalPrice = totalPrice.replace(',', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "");
              totalPrice = parseFloat(totalPrice);
             //console.log('===== 2=> '+totalPrice);
 /* if(priceInst > totalPrice){
    
      jQuery('body').find(".product-info__block-item .show_installation_price").parent().hide();
      jQuery('body').find(".product-info__block-item .show_summary_price").parent().hide();   
      jQuery('body').find(".product-info__block-item .price-list--product").hide();
    
        jQuery('body').find('input[name="properties[_Dimension Installation_x]"]').val('');
        jQuery('body').find('input[name="properties[_Dimension Installation_y]"]').val('');
  }*/

      
            let remindPrice  = totalPrice-priceInst;
                priceInst = parseFloat(priceInst).toFixed(2)
                priceInst = " $"+addCommas(priceInst);
                remindPrice = remindPrice.toFixed(2);
                remindPrice  = ' $'+addCommas(remindPrice);
       
          let title  = jQuery('body').find(".product-info__block-list .product-title").html();
      
         let mt  = jQuery('body').find('select[name="properties[Material]"]').val();
         let sp  = jQuery('body').find('select[name="properties[Special Effects]"]').val();
         let ef  = jQuery('body').find('select[name="properties[Effects]"]').val();
         let is_material  = 'no';
      
          let summaryText  = title+', '+x+'x'+y+' inches';
               if(mt && mt.indexOf("Select")== '-1'){summaryText = summaryText+', '+mt; is_material = 'yes';}
               if(sp && sp.indexOf("Select")== '-1'){summaryText = summaryText+', '+sp;}
               if(ef && ef.indexOf("Select")== '-1'){summaryText = summaryText+', '+ef;}
             summaryText = summaryText+':';

      if(is_material == 'yes'){
          jQuery('body').find(".product-info__block-item .show_installation_price").parent().show();
          jQuery('body').find(".product-info__block-item .show_installation_price span").html(priceInst);
      
          jQuery('body').find(".product-info__block-item .show_summary_price").parent().show();   
          jQuery('body').find(".product-info__block-item .show_summary_price strong").html(summaryText); 
          jQuery('body').find(".product-info__block-item .show_summary_price span").html(remindPrice);

         jQuery('body').find(".product-info__block-item .price-list--product").show();
      }
  }
      
  }
   }, 500); 
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function addCommas(nStr)
{
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}